import { IconBaseProps } from 'react-icons';
import { FaCircleNotch, FaSpinner } from 'react-icons/fa';

import { Theme, styled } from '../theme';

const spinAnimation = ({ theme }: { theme: Theme }) => ({
    animation: theme.animations.spin,
});

const DotsSpinner = styled(FaSpinner)(spinAnimation);
const ArcSpinner = styled(FaCircleNotch)(spinAnimation);

type Props = IconBaseProps & {
    variant?: 'dots' | 'arc';
};

const Spinner = ({ variant = 'dots', ...props }: Props) =>
    variant === 'arc' ? <ArcSpinner {...props} /> : <DotsSpinner {...props} />;

export default Spinner;
